<div class="year-filter">
  <mat-form-field appearance="outline">
    <input matInput
      [matDatepicker]="fromDate"
      [max]="dateTo || today"
      [min]="minDate"
      [(ngModel)]="dateFrom"
    >
    <mat-label>From</mat-label>
    <mat-datepicker-toggle matIconSuffix [for]="fromDate"></mat-datepicker-toggle>
    <mat-datepicker #fromDate
      startView="multi-year"
      (yearSelected)="onYearSelected($event, fromDate, 'dateFrom')"
    ></mat-datepicker>
  </mat-form-field>

  <mat-form-field appearance="outline">
    <mat-label>To</mat-label>
    <input matInput
      [matDatepicker]="toDate"
      [min]="dateFrom || minDate"
      [max]="today"
      [(ngModel)]="dateTo"
    >
    <mat-datepicker-toggle matIconSuffix [for]="toDate"></mat-datepicker-toggle>
    <mat-datepicker #toDate
      startView="multi-year"
      (yearSelected)="onYearSelected($event, toDate, 'dateTo')"
    ></mat-datepicker>
  </mat-form-field>
</div>
